let build_json = null;
//.version to get version number and .date to get version date
const Build = {
    get: async function () {
        let i = Math.floor(Math.random() * 1000000);

        if (build_json === null) {
            const response = await fetch("build.json?i=" + i);

            build_json = response.status === 204
                ? null
                : await response.json();
        }

        return build_json;
    },
};

export default Build;
